import { GET, DELETE } from '../request'

export const getModificados = ({ mes, centro }) =>
  GET('/api/core/contabilidad/pago/list/modified', { mes, centro })

export const getFromAlumno = ({ alumno }) =>
  GET('/api/core/contabilidad/pago/list/alumno', { alumno })

export const getPendientes = ({ mes, centro }) =>
  GET('/api/core/contabilidad/pago/list/pending', { mes, centro })

export const deletePago = ({ id }) =>
  DELETE('/api/core/contabilidad/pago', { id })
